import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';


@Pipe({
  name: 'humanizeDuration'
})
export class HumanizeDurationPipe implements PipeTransform {

  /**
   * @param to in format 'DD-MM-YYYY'
   * @param from in format 'DD-MM-YYYY'
   * @returns humanized duration as example: "1 month"
   */
  transform(to: string, from: string): string {
    return moment.duration(moment(to).diff(from)).humanize();
  }
}
